// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23hih","buttons":"styles_buttons__3TXp-"};